
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M512 34.133333C153.6 34.133333 34.133333 153.6 34.133333 512s119.466667 477.866667 477.866667 477.866667 477.866667-119.466667 477.866667-477.866667S870.4 34.133333 512 34.133333z m194.56 624.64c10.24 13.653333 6.826667 37.546667-6.826667 47.786667-13.653333 10.24-27.306667 10.24-40.96 0L512 559.786667l-146.773333 146.773333c-10.24 13.653333-34.133333 17.066667-47.786667 6.826667-13.653333-10.24-17.066667-34.133333-6.826667-47.786667l6.826667-6.826667 146.773333-146.773333-146.773333-146.773333c-10.24-13.653333-6.826667-37.546667 6.826667-47.786667 13.653333-10.24 27.306667-10.24 40.96 0l146.773333 146.773333 146.773333-146.773333c10.24-13.653333 34.133333-17.066667 47.786667-6.826667 13.653333 10.24 17.066667 34.133333 6.826667 47.786667l-6.826667 6.826667-146.773333 146.773333 146.773333 146.773333z"
      }
    }
  ]
})
    }
  